module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ActivitySearchView.js"));
	}, "ActivitySearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ActivitySearchView!./src/pages/Promote/OfflineActivity/ActivityCenter/ActivitySearch/ActivitySearchView.js
// module id = 1676
// module chunks = 418